import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../../styles/3ds2/main.module.css'

const OBJECT = [ "receipt", "receipt", "$mpgResponse->"]
const METHODS = {
    ECI: [ ".GetMpiEci()", ".getMpiEci()", "getMpiEci()"],
    Message: [ ".GetMessage();", ".getMessage();", "getMessage();"],
    Receipt_Id: [ ".GetReceiptId();", ".getReceiptId();", "getReceiptId();"],
    CAVV: [ ".GetMpiCavv()", ".getMpiCavv()", "getMpiCavv()"],
    Challenge_Completion_Indicator: [ ".GetMpiChallengeCompletionIndicator()", ".getMpiChallengeCompletionIndicator()", "getMpiChallengeCompletionIndicator()"],
    Challenge_URL: [ ".GetMpiChallengeURL()", ".getMpiChallengeURL()", "getMpiChallengeURL()"],
    Message_Type: [ ".GetMpiMessageType()", ".getMpiMessageType()", "getMpiMessageType()"],
    ThreeDSMethodURL: [ ".GetMpiThreeDSMethodURL()", ".getMpiThreeDSMethodURL()", "getMpiThreeDSMethodURL()"],
    ThreeDSMethodData: [ ".GetMpiThreeDSMethodData()", ".getMpiThreeDSMethodData()", "getMpiThreeDSMethodData()"],
    ThreeDSServer_TransID: [ ".GetMpiThreeDSServerTransId()", ".getMpiThreeDSServerTransId()", "getMpiThreeDSServerTransId()"],
    ThreeDSVersion: [ ".GetThreeDSVersion();", ".getThreeDSVersion();", "getThreeDSVersion();"],
    Transaction_Status: [ ".GetMpiTransStatus()", ".getMpiTransStatus()", "getMpiTransStatus()"],
    
    Challenge_Data: [ ".GetMpiChallengeData()", ".getMpiChallengeData()", "getMpiChallengeData()"],
    DS_TransId: [ ".GetMpiDSTransId()", ".getMpiDSTransId()", "getMpiDSTransId()"],
    Trans_Status_Reason: [ ".GetMpiTransStatusReason()", ".getMpiTransStatusReason()", "getMpiTransStatusReason()"],
    Cardholder_Info: [ ".GetMpiCardholderInfo()", ".getMpiCardholderInfo()", "getMpiCardholderInfo()"],
    Authentication_Type: [ ".GetMpiAuthenticationType()", ".getMpiAuthenticationType()", "getMpiAuthenticationType()"],
    ThreeDS_Acs_TransID: [ ".GetMpiThreeDSAcsTransID()", ".getMpiThreeDSAcsTransID()", "getMpiThreeDSAcsTransID()"],
    ThreeDS_Auth_TimeStamp: [ ".GetMpiThreeDSAuthTimeStamp()", ".getMpiThreeDSAuthTimeStamp()", "getMpiThreeDSAuthTimeStamp()"],
}

export class References extends Component {
    state = {
        topRef: React.createRef(),
        firtRef: React.createRef(),
        secondRef: React.createRef(),
        thirdRef: React.createRef(),
        fourthRef: React.createRef(),
        fifthRef: React.createRef(),
        sixthRef: React.createRef()
    }

    onScrollToTop() {
        this.state.topRef.current.scrollIntoView()
        window.document.body.scrollIntoView(true)
    }

    scrollTo(refNum) {
        switch(refNum) {
            case 1:
                this.state.firtRef.current.scrollIntoView()
                break
            case 2:
                this.state.secondRef.current.scrollIntoView()
                break
            case 3:
                this.state.thirdRef.current.scrollIntoView()
                break
            case 4:
                this.state.fourthRef.current.scrollIntoView()
                break
            case 5:
                this.state.fifthRef.current.scrollIntoView()
                break
            case 6:
                this.state.sixthRef.current.scrollIntoView()
                break
            default:
                window.document.body.scrollIntoView(true)
        }
        window.document.body.scrollIntoView(true)
    }

    renderTitle() {
        if(this.props.mode === 'integration_guide') {
            return (
                <span className="stepPageTitle"><b>References</b></span>
            );
        }
    }

    render() {
        const { progLangId, mode, selectedStep } = this.props;
        const { leftContents, stepContainer } = styles;

        if(mode === 'integration_guide' || selectedStep === 9) {
            return (
                <div className={mode === 'integration_guide' ? stepContainer : leftContents} style={{borderWidth: '0px'}}>
                    <div ref={this.state.topRef} style={{ paddingTop: '1vh', paddingRight: '1vw', paddingLeft: '1vw' }}>
                        {this.renderTitle()}
                        <ul style={{marginTop: mode === 'integration_guide' ? '5vh' : '0vh'}}>
                            <li style={{ color: '#00a1cb', cursor: 'pointer'}} onClick={() => this.scrollTo(1)}>9.1 Definition of Response Fields – Core Fields</li>
                            <li style={{ marginTop: '2vh', color: '#00a1cb', cursor: 'pointer'}} onClick={() => this.scrollTo(2)}>9.2 Definition of Response Fields – 3-D Secure</li>
                            <li style={{ marginTop: '2vh', color: '#00a1cb', cursor: 'pointer'}} onClick={() => this.scrollTo(3)}>9.3 3-D Secure 2.2 TransStatus Codes</li>
                            <li style={{ marginTop: '2vh', color: '#00a1cb', cursor: 'pointer'}} onClick={() => this.scrollTo(4)}>9.4 CAVV Result Codes</li>
                            <li style={{ marginTop: '2vh', color: '#00a1cb', cursor: 'pointer'}} onClick={() => this.scrollTo(5)}>9.5 3-D Secure 2.2 Commons TransStatusReason Decline Codes</li>
                            <li style={{ marginTop: '2vh', color: '#00a1cb', cursor: 'pointer'}} onClick={() => this.scrollTo(6)}>9.6 Commons 3DS Response Codes</li>
                        </ul>

                        <h3 ref={this.state.firtRef} style={{ color: '#00a1cb', marginTop: '7vh'}}>9.1 Definition of Response Fields – Core Fields</h3>
                        <table>
                            <th>Variable Name</th>
                            <th>Description</th>
                            <th>Get Method</th>

                            <tr>
                                <td>ECI</td>
                                <td>e-commerce indicator (crypt_type) to be provided in the financial request</td>
                                <td><code>{OBJECT[progLangId]}{METHODS.ECI[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>Message</td>
                                <td>Response message</td>
                                <td><code>{OBJECT[progLangId]}{METHODS.Message[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>Receipt Id</td>
                                <td>Echo of the orderID from the request</td>
                                <td><code>{OBJECT[progLangId]}{METHODS.Receipt_Id[progLangId]}</code></td>
                            </tr>
                        </table>

                        <h3 ref={this.state.secondRef} style={{ color: '#00a1cb', marginTop: '15vh'}}>9.2 Definition of Response Fields – 3-D Secure</h3>
                        <p>The following response fields are specific to 3-D Secure transactions</p>
                        <table className='four_cols_table'>
                            <th>Variable Name</th>
                            <th>Description</th>
                            <th>Get Method</th>

                            <tr>
                                <td>Challenge data</td>
                                <td>If the transStatus is “C” this field will be populated with the data to post the challengeURL. The data must be posted in a field with the name “creq”.</td>
                                <td><code>{OBJECT[progLangId]}{METHODS.Challenge_Data[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>ECI</td>
                                <td>Crypt Type to be provided in the financial request.</td>
                                <td><code>{OBJECT[progLangId]}{METHODS.ECI[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>DS Trans ID</td>
                                <td>Universally unique transaction identifier assigned by the DS to identify a single  transaction. Refers to the DSTransID in the response of the previous 3DS authentication.</td>
                                {/* <td>Provides additional information on why the TransStatus field has the specified value.<br/><br/>Possible values:
                                <ul>
                                    <li>01 = Card authentication failed</li>
                                    <li>02 = Unknown Device</li>
                                    <li>03 = Unsupported Device</li>
                                    <li>04 = Exceeds authentication frequency limit</li>
                                    <li>05 = Expired card</li>
                                    <li>06 = Invalid card number</li>
                                    <li>07 = Invalid transaction</li>
                                    <li>08 = No Card record</li>
                                    <li>09 = Security failure</li>
                                    <li>10 = Stolen card</li>
                                    <li>11 = Suspected fraud</li>
                                    <li>12 = Transaction not permitted to cardholder</li>
                                    <li>13 = Cardholder not enrolled in service</li>
                                    <li>14 = Transaction timed out at the ACS</li>
                                    <li>15 = Low confidence</li>
                                    <li>16 = Medium confidence</li>
                                </ul>
                                </td> */}
                                <td><code>{OBJECT[progLangId]}{METHODS.DS_TransId[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>Transaction Status Reason</td>
                                <td>Provides additional information on why the TransStatus field has the specified value.<br/><br/>Possible values:
                                <ul>
                                    <li>01 = Card authentication failed</li>
                                    <li>02 = Unknown Device</li>
                                    <li>03 = Unsupported Device</li>
                                    <li>04 = Exceeds authentication frequency limit</li>
                                    <li>05 = Expired card</li>
                                    <li>06 = Invalid card number</li>
                                    <li>07 = Invalid transaction</li>
                                    <li>08 = No Card record</li>
                                    <li>09 = Security failure</li>
                                    <li>10 = Stolen card</li>
                                    <li>11 = Suspected fraud</li>
                                    <li>12 = Transaction not permitted to cardholder</li>
                                    <li>13 = Cardholder not enrolled in service</li>
                                    <li>14 = Transaction timed out at the ACS</li>
                                    <li>15 = Low confidence</li>
                                    <li>16 = Medium confidence</li>
                                </ul>
                                </td>
                                <td><code>{OBJECT[progLangId]}{METHODS.Trans_Status_Reason[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>Cardholder Information</td>
                                <td>Text provided by the ACS/Issuer to Cardholder during a Frictionless or Decoupled transaction. This provides information to the cardholder. For example, “Additional authentication is needed for this transaction, please contact (Issuer Name) at xxx-xxx-xxxx.”</td>
                                <td><code>{OBJECT[progLangId]}{METHODS.Cardholder_Info[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>Authentication-Type</td>
                                <td>Authentication method the issuer will use to challenge the cardholder.
                                    <ul>
                                        <li>01 = Static</li>
                                        <li>02 = Dynamic</li>
                                        <li>03 = OOB</li>
                                        <li>04 = Decoupled</li>
                                    </ul>
                                </td>
                                <td><code>{OBJECT[progLangId]}{METHODS.Authentication_Type[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>3DS ACS Transaction ID</td>
                                <td>Universally Unique transaction identifier assigned by the issuer Access Control Server (ACS) to identify a single transaction.</td>
                                <td><code>{OBJECT[progLangId]}{METHODS.ThreeDS_Acs_TransID[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>3DS Auth TimeStamp</td>
                                <td>Date and time in UTC of the cardholder authentication.<br />Date format = YYYYMMDDHHMM</td>
                                <td><code>{OBJECT[progLangId]}{METHODS.ThreeDS_Auth_TimeStamp[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>CAVV</td>
                                <td>Cardholder Authentication Value, to be provided in the financial request</td>
                                <td><code>{OBJECT[progLangId]}<br />{METHODS.CAVV[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>Challenge Completion Indicator</td>
                                <td>Challenge Completion Indicator indicates if the challenge was completed</td>
                                <td><code>{OBJECT[progLangId]}<br />{METHODS.Challenge_Completion_Indicator[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>Challenge URL</td>
                                <td>If the transStatus is “C” this field will be populated with the URL to POST the challengeData to create the cardholder challenge screen</td>
                                <td><code>{OBJECT[progLangId]}<br />{METHODS.Challenge_URL[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>Message Type</td>
                                <td>Denotes the request message<br /><br /> EMV nomenclature “ARES”</td>
                                <td><code>{OBJECT[progLangId]}<br />{METHODS.Message_Type[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>ThreeDSMethodURL</td>
                                <td>Device fingerprinting end point</td>
                                <td><code>{OBJECT[progLangId]}<br />{METHODS.ThreeDSMethodURL[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>ThreeDSMethodData</td>
                                <td>Data that must be posted to 3DS Method URL</td>
                                <td><code>{OBJECT[progLangId]}<br />{METHODS.ThreeDSMethodData[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>ThreeDSServerTransID</td>
                                <td>3DS unique transaction identifier</td>
                                <td><code>{OBJECT[progLangId]}<br />{METHODS.ThreeDSServer_TransID[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>ThreeDSVersion</td>
                                <td>3-D Secure version</td>
                                <td><code>{OBJECT[progLangId]}<br />{METHODS.ThreeDSVersion[progLangId]}</code></td>
                            </tr>
                            <tr>
                                <td>Transaction Status</td>
                                <td>Indicates the ACS result<br /><br /> For more information about this field, see 9.3 3-D Secure 2.2 TransStatus Codes</td>
                                <td><code>{OBJECT[progLangId]}<br />{METHODS.Transaction_Status[progLangId]}</code></td>
                            </tr>
                        </table>


                        <h3 ref={this.state.thirdRef} style={{ color: '#00a1cb', marginTop: '15vh'}}>9.3 3-D Secure 2.2 TransStatus Codes</h3>
                        <table>
                            <th>VALUE</th>
                            <th>DESCRIPTION</th>
                            <th>COMMENTS</th>

                            <tr>
                                <td>Y</td>
                                <td>Authenticated</td>
                                <td>Cardholder has been fully authenticated</td>
                            </tr>
                            <tr>
                                <td>D</td>
                                <td>Challenge Required (Decoupled)</td>
                                <td>Cardholder requires a challenge using Decoupled Authentication</td>
                            </tr>
                            <tr>
                                <td>A</td>
                                <td>Authentication Attempt</td>
                                <td>A proof of authentication attempt was generated</td>
                            </tr>
                            <tr>
                                <td>C</td>
                                <td>Challenge Required</td>
                                <td>Cardholder requires a challenge to complete authentication</td>
                            </tr>
                            <tr>
                                <td>U</td>
                                <td>Not Authenticated</td>
                                <td>Authentication could not be performed due to technical or other issue</td>
                            </tr>
                            <tr>
                                <td>N</td>
                                <td>Not Authenticated</td>
                                <td>Not authenticated</td>
                            </tr>
                            <tr>
                                <td>R</td>
                                <td>Not Authenticated</td>
                                <td>Not authenticated because the Issuer is rejecting authentication and requesting that authorisation not be attempted</td>
                            </tr>
                        </table>

                        <h3 style={{ color: '#00a1cb', marginTop: '15vh'}}>Visa Secure, MasterCard Identity Check and American Express SafeKey Responses</h3>
                        <p>For each transaction, a crypt type is sent to identify whether it is a Visa Secure-, MasterCard Identity Check- or American Express SafeKey-authenticated transaction. Below are the tables defining the possible crypt types</p>
                        <table className='four_cols_table'>
                            <th>Crypt type</th>
                            <th>Visa definition</th>
                            <th>MasterCard definition</th>
                            <th>American Express Definition</th>

                            <tr>
                                <td>5</td>
                                <td><ul><li>Fully authenticated</li><li>There is a liability shift, and the merchant is protected from chargebacks</li></ul></td>
                                <td><ul><li>Fully authenticated</li><li>There is a liability shift, and the merchant is protected from chargebacks.</li></ul></td>
                                <td><ul><li>Fully authenticated</li><li>There is a liability shift, and the merchant is protected from chargebacks.</li></ul></td>
                            </tr>

                            <tr>
                                <td>6</td>
                                <td><ul><li>Visa Secure has been attempted</li><li>There is a liability shift, and the merchant is protected from certain chargebacks on fraudulent transactions</li></ul></td>
                                <td><ul><li>MasterCard Identity Check has been attempted</li><li>There is a liability shift, and the merchant is protected from certain chargebacks on fraudulent transactions</li></ul></td>
                                <td><ul><li>American Express SafeKey has been attempted</li><li>There is a liability shift, and the merchant is protected from certain chargebacks on fraudulent transactions</li></ul></td>
                            </tr>

                            <tr>
                                <td>7</td>
                                <td><ul><li>Non-Visa Secure transaction</li><li>No liability shift</li><li>Merchant is not protected from chargebacks</li></ul></td>
                                <td><ul><li>Non-MasterCard Identity Check transaction</li><li>No liability shift</li><li>Merchant is not protected from chargebacks</li></ul></td>
                                <td><ul><li>Non-American Express SafeKey transaction</li><li>No liability shift</li><li>Merchant is not protected from chargebacks</li></ul></td>
                            </tr>
                        </table>

                        <h3 ref={this.state.fourthRef} style={{ marginTop: '15vh', color: '#00a1cb'}}>9.4 CAVV Result Codes</h3>
                        <p>The Cardholder Authentication Verification Value (CAVV), the Accountholder Authentication Value (AAV), and the American Express Verification Value (AEVV), are the values that allows Visa, Mastercard and American Express to validate the integrity of the Visa Secure, MasterCard Identity Check and American Express SafeKey transaction data. These values are passed back from the issuer to the merchant after the authentication has taken place. The merchant then integrates the CAVV/AAV/AEVV value into the authorization request using the Purchase or Pre-Authorization with 3-D Secure transaction type.</p>
                        <p>To summarize this process:</p>
                        <ol style={{ paddingLeft: '2vw'}}>
                            <li style={{ marginTop: '3vh'}}>Merchant conducts 3-D Secure authentication request and receives CAVV/AAV/AEVV value in response</li>
                            <li style={{ marginTop: '3vh'}}>Merchant sends the CAVV/AAV/AEVV value to Moneris using the Purchase or Pre-Authorization with 3-D Secure transaction type and receives the CAVV result code in the response</li>
                        </ol>
                        <p style={{ marginTop: '4vh'}}>The following tables describe the contents of the CAVV data response and what it means to the merchant.</p>

                        <h3 style={{ marginTop: '15vh', color: '#00a1cb'}}>9.4.1 Visa CAVV Result Codes</h3>
                        <table>
                            <th>Result Code</th>
                            <th>Message</th>
                            <th>Significance to Merchants</th>

                            <tr>
                                <td>Blank</td>
                                <td>CAVV not present or not verified</td>
                                <td>Not a Visa Secure transaction. No liability shift and merchant is not protected from chargebacks</td>
                            </tr>
                            <tr>
                                <td>0</td>
                                <td>CAVV authentication results invalid</td>
                                <td>Not a Visa Secure transaction. No liability shift and merchant is not protected from chargebacks</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>CAVV failed validation (authentication)</td>
                                <td>Provided that you have implemented the Visa Secure process correctly the liability for this transaction should remain with the Issuer for chargeback reason codes covered by Verified by Visa.</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>CAVV passed validation (authentication)</td>
                                <td>Fully authenticated transaction. There is a liability shift and the merchant is protected from chargebacks.</td>
                            </tr>
                            <tr>
                                <td>3,8,A</td>
                                <td>CAVV passed validation (attempt)</td>
                                <td>Visa Secure has been attempted. There is a liability shift and the merchant is protected from certain card fraud-related chargebacks.</td>
                            </tr>
                            <tr>
                                <td>4,7,9</td>
                                <td>CAVV failed validation (attempt)</td>
                                <td>Visa Secure has been attempted. There is a liability shift and the merchant is protected from certain card fraud-related chargebacks.</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>CAVV not validated - Issuer not participating</td>
                                <td>Visa Secure has been attempted. There is a liability shift and the merchant is protected from certain card fraud-related chargebacks.</td>
                            </tr>
                            <tr>
                                <td>B</td>
                                <td>CAVV passed validation; info only</td>
                                <td>Not a Visa Secure transaction. No liability shift and merchant is not protected from chargebacks</td>
                            </tr>
                            <tr>
                                <td>C</td>
                                <td>CAVV was not validated (attempt)</td>
                                <td>Visa Secure has been attempted. There is a liability shift and the merchant is protected from certain card fraud-related chargebacks.</td>
                            </tr>
                            <tr>
                                <td>D</td>
                                <td>CAVV was not validated (authentication)</td>
                                <td>Visa Secure has been attempted. There is a liability shift and the merchant is protected from certain card fraud-related chargebacks.</td>
                            </tr>
                        </table>

                        <h3 style={{ marginTop: '15vh', color: '#00a1cb'}}>9.4.2 Mastercard CAVV Result Codes</h3>
                        <table>
                            <th>Result Code</th>
                            <th>Message</th>
                            <th>Significance to Merchants</th>

                            <tr>
                                <td>0</td>
                                <td>Authentication failed</td>
                                <td>Not a MasterCard Identity Check transaction. No liability shift and merchant is not protected from chargebacks</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Authentication attempted</td>
                                <td>MasterCard Identity Check has been attempted. There is a liability shift and the merchant is protected from certain card fraud-related chargebacks (international commercial cards excluded).</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Authentication successful</td>
                                <td>Fully authenticated transaction. There is a liability shift and the merchant is protected from chargebacks.</td>
                            </tr>
                        </table>

                        <h3 style={{ marginTop: '7vh', color: '#00a1cb'}}>9.4.3 American Express CAVV Result Codes</h3>
                        <p className="note"><b>NOTE: </b>American Express SafeKey is only available to American Express direct acquired merchants (i.e., not OptBlue merchants). Any questions pertaining to chargebacks, liability and disputes should be addressed to your American Express representative given that American Express is the acquirer of record for these merchants.</p>
                        <table>
                            <th>RESULT CODE</th>
                            <th>MESSAGE</th>

                            <tr>
                                <td>1</td>
                                <td>AEVV Failed - Authentication, Issuer Key</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>AEVV Passed - Authentication, Issuer Key</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>AEVV Passed - Attempt, Issuer Key</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>AEVV Failed - Attempt, Issuer Key</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>AEVV Failed - Attempt, Issuer not participating, Network Key</td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>AEVV Passed - Attempt, Issuer not participating, Network Key</td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>AEVV Failed - Attempt, Participating, Access Control Server (ACS) not available, Network Key</td>
                            </tr>
                            <tr>
                                <td>A</td>
                                <td>AEVV Passed - Attempt, Participating, Access Control Server (ACS) not available, Network Key</td>
                            </tr>
                            <tr>
                                <td>U</td>
                                <td>AEVV Unchecked</td>
                            </tr>
                        </table>

                        <h3 style={{ marginTop: '7vh', color: '#00a1cb'}}>Visa EMV 3DS Transaction Status Reason Code</h3>
                        <table>
                            <th>VALUE</th>
                            <th>DESCRIPTION</th>

                            <tr>
                                <td>80</td>
                                <td>Error connecting to ACS</td>
                            </tr>
                            <tr>
                                <td>81</td>
                                <td>ACS timed out</td>
                            </tr>
                            <tr>
                                <td>82</td>
                                <td>Invalid response from ACS</td>
                            </tr>
                            <tr>
                                <td>83</td>
                                <td>System Error response from ACS</td>
                            </tr>
                            <tr>
                                <td>84</td>
                                <td>VMID not eligible for requested program</td>
                            </tr>
                            <tr>
                                <td>85</td>
                                <td>VMID not eligible for requested program</td>
                            </tr>
                            <tr>
                                <td>86</td>
                                <td>Protocol version not supported by ACS</td>
                            </tr>
                            <tr>
                                <td>87</td>
                                <td>Transaction is excluded from Attempts Processing (includes non-reloadable pre-paid cards and non-payments (NPA))</td>
                            </tr>
                            <tr>
                                <td>88</td>
                                <td>Requested program not supported by ACS</td>
                            </tr>
                        </table>

                        <h3 style={{ marginTop: '7vh', color: '#00a1cb'}}>MasterCard EMV 3DS Transaction Status Reason Code</h3>
                        <table>
                            <th>VALUE</th>
                            <th>DESCRIPTION</th>

                            <tr>
                                <td>80</td>
                                <td>Returned on all Data Only authentications</td>
                            </tr>
                            <tr>
                                <td>81</td>
                                <td>Challenge exemption accepted</td>
                            </tr>
                            <tr>
                                <td>82</td>
                                <td>Challenge Mandate requested but could not be performed</td>
                            </tr>
                            <tr>
                                <td>87</td>
                                <td>Device Channel is 3RI therefore did not route to Smart Authentication Stand-In</td>
                            </tr>
                            <tr>
                                <td>88</td>
                                <td>3DS Requestor Prior Transaction Authentication Data was provided but not found by the ACS or it was expired.</td>
                            </tr>
                        </table>

                        <h3 ref={this.state.fifthRef} style={{ color: '#00a1cb', marginTop: '15vh'}}>9.5 3-D Secure 2.2 Commons TransStatusReason Decline Codes</h3>
                        <p>The following codes are returned by the 3-D Secure service in order to provide additional information about the 3-D Secure transaction status.</p>
                        <table>
                            <th>TransStatusReason Code</th>
                            <th>Description</th>

                            <tr>
                                <td>01</td>
                                <td>Card authentication failed</td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td>Unknown Device</td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>Unsupported Device</td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>Exceeds authentication frequency limit</td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>Expired card</td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td>Invalid card number</td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td>Invalid transaction</td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>No Card record</td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>Security failure</td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>Stolen card</td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>Suspected fraud</td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>Transaction not permitted to cardholder</td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>Cardholder not enrolled in service</td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>Transaction timed out at the ACS</td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>Low confidence</td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>Medium confidence</td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>High confidence</td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>Very High confidence</td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>Exceeds ACS maximum challenges</td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>Non-Payment transaction not supported</td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>3RI transaction not supported</td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>ACS technical issue</td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>Decoupled Authentication required by ACS but not requested by 3DS Requestor</td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>3DS Requestor Decoupled Max Expiry Time exceeded</td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>Decoupled Authentication was provided insufficient time to authenticate cardholder. ACS will not make attempt</td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>Authentication attempted but not performed by the cardholder</td>
                            </tr>
                        </table>
                        <div style={{ width: '80%',backgroundColor: '#9df0ef', padding: '2px 10px', border: '1px solid #000', borderRadius: '10px' ,marginBottom: '5vh', marginTop: '5vh', marginRight: '2vw' }}>
                            <p style={{ color: '#000'}}><strong>NOTE: </strong> For a list of all TransStatus Decline Codes, please see Reference session of 3D Secure 2.2 at https://developer.moneris.com.</p>
                        </div>

                        <h3 ref={this.state.sixthRef} style={{ color: '#00a1cb', marginTop: '15vh'}}>9.6 Commons 3DS Response Codes</h3>
                        <table>
                            <th>3DS Response Code</th>
                            <th>Description</th>
                            <tr>
                                <td>101</td>
                                <td>Invalid message</td>
                            </tr>
                            <tr>
                                <td>102</td>
                                <td>3DS message version not supported</td>
                            </tr>
                            <tr>
                                <td>201</td>
                                <td>A required field is missing</td>
                            </tr>
                            <tr>
                                <td>202</td>
                                <td>Critical message extensions not recognized</td>
                            </tr>
                            <tr>
                                <td>203</td>
                                <td>The format of one or more of the fields is invalid</td>
                            </tr>
                            <tr>
                                <td>204</td>
                                <td>One or more fields is duplicated</td>
                            </tr>

                            <tr>
                                <td>301</td>
                                <td>A transaction ID was invalid (threeDSServerTransID, dsTransID, acsTransID or sdkTransID)</td>
                            </tr>
                            <tr>
                                <td>302</td>
                                <td>Data decryption failure</td>
                            </tr>
                            <tr>
                                <td>303</td>
                                <td>Access denied</td>
                            </tr>
                            <tr>
                                <td>304</td>
                                <td>ISO country or currency code was invalid</td>
                            </tr>
                            <tr>
                                <td>305</td>
                                <td>Transaction data was invalid</td>
                            </tr>
                            <tr>
                                <td>306</td>
                                <td>Merchant Category Code (MCC) was invalid for the payment system</td>
                            </tr>
                            <tr>
                                <td>402</td>
                                <td>Transaction timed out</td>
                            </tr>
                            <tr>
                                <td>403</td>
                                <td>Transient system failure</td>
                            </tr>
                            <tr>
                                <td>404</td>
                                <td>Permanent system failure</td>
                            </tr>
                            <tr>
                                <td>405</td>
                                <td>System connection failure</td>
                            </tr>
                            <tr>
                                <td>900</td>
                                <td>CAVV NOT FOUND</td>
                            </tr>
                        </table>
                    </div>
                </div>
            )
        }
        else {
            return null
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { selection } = state.threeDSTwo.stepsList;
    return { progLangId: state.common.progLangList.selection, mode, selectedStep: selection };
}

export default connect(mapStateToProps, {})(References)
